import { useEffect, useRef, useMemo } from "react";

const OPEN_GIVING_FORM_QUERY_FLAG = "open_giving_form=true";
const AUTO_LOAD_CATEGORY_CAPTURE = /auto_load_category=([^&]*)/;
const STRIP_OPEN_GIVING_FORM_FROM_HASH_PATTERN = /open_giving_form=true[&]*/;

export const stripOpenGivingFormFlagFromHash = (
  hash: string | undefined | null,
): string | undefined | null => {
  if (!hash) {
    return hash;
  }
  return hash.replace(STRIP_OPEN_GIVING_FORM_FROM_HASH_PATTERN, "");
};

export type LinkRouterLocation = {
  search: string;
  hash: string;
};

export type UseListenGivingFormRouterParams = {
  location: LinkRouterLocation;
  setCategory?: (category: string) => void;
  onOpenGivingFormFromUrl?: (autoCategory?: string) => void;
};

export const useListenGivingFormRouter = ({
  location,
  setCategory,
  onOpenGivingFormFromUrl,
}: UseListenGivingFormRouterParams): {
  shouldOpenGivingForm: boolean;
  autoCategory: string | undefined;
} => {
  const hasOpenedGivingFormRef = useRef(false);

  const shouldOpenGivingForm = useMemo(() => {
    return `${location.search ?? ""}${location.hash ?? ""}`.includes(
      OPEN_GIVING_FORM_QUERY_FLAG,
    );
  }, [location.search, location.hash]);

  const autoCategory = useMemo(() => {
    const rawCategory = `${location.search ?? ""}${location.hash ?? ""}`.match(AUTO_LOAD_CATEGORY_CAPTURE)?.[1];
    return rawCategory ? decodeURIComponent(rawCategory) : undefined;
  }, [location.search, location.hash]);

  useEffect(() => {
    if (
      shouldOpenGivingForm &&
      !hasOpenedGivingFormRef.current && onOpenGivingFormFromUrl
    ) {
      onOpenGivingFormFromUrl?.(autoCategory);
      hasOpenedGivingFormRef.current = true;
    }
    if (autoCategory && setCategory) {
      setCategory(autoCategory);
    }
  }, [location]);

  return {
    shouldOpenGivingForm,
    autoCategory,
  }
};
